import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraBadge } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { describeReviewState } from './reviewState';
import { useSectionReviewState } from './useProposalReviews';
export function ReviewStateLabel({ state }) {
    const { text, tone } = describeReviewState(state);
    return /*#__PURE__*/ _jsx(SpecraBadge, {
        variant: tone,
        "data-testid": Testids.proposalReviews.sectionReviewBadge,
        children: text
    });
}
/** A section's review state as of its current content, for the editor header. */ export function SectionReviewStatus({ projectId, sectionId }) {
    const { data, isError } = useSectionReviewState(projectId, sectionId);
    if (isError) return null;
    return /*#__PURE__*/ _jsx(ReviewStateLabel, {
        state: data
    });
}
